(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('SectionType', SectionType);

    SectionType.$inject = ['$resource', 'DateUtils'];

    function SectionType ($resource, DateUtils) {
        var resourceUrl =  'api/section-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('SectionTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getsectiontypebyname = function (data,callback){
		$http.get('api/section-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('SectionTypeSearch', SectionTypeSearch);

    SectionTypeSearch.$inject = ['$resource'];

    function SectionTypeSearch ($resource) {
        var service = $resource('/api/section-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomSectionTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-section-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();